/**
 * @desc applyLogistics
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderApplyOperationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/outPlan/applyLogistics`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
